import type { ApiOrgId } from '#/api/types/ApiTypedId';
import type { OrgDashboardGradFairsApiDetails } from '#/modules/orgDashboard/gradFairs/api/types/OrgDashboardGradFairsApiDetails';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = OrgDashboardGradFairsApiDetails;

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) => `/data/orgdashboard/${orgId}/grad-fairs`,
  mapResponse,
});

// Exports

export const orgDashboardGradFairsApiIsomorphicFetchDetails =
  endpoint.createIsomorphicFetchFn();

export const orgDashboardGradFairsApiClientFetchDetails =
  endpoint.createClientFetchFn();
